import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Entitlement, TrialStatusResponse, toEntitlement } from './models';

// Shared fail-open evaluator (contratos-congelados Slice C1).
// A missing or unknown entitlement MUST grant full access: only an explicit
// false flag, or a complete screensInUse >= maxScreens pair, may restrict.
export function isAllowed(flag?: boolean): boolean {
  return flag !== false;
}

export function hasFeature(entitlement: Entitlement | null, key: string): boolean {
  if (!entitlement || !entitlement.features) { return true; }
  const value = entitlement.features[key];
  if (value === undefined || value === null) { return true; }
  return !!value;
}

export function isAtCap(entitlement: Entitlement | null): boolean {
  if (!entitlement || entitlement.maxScreens == null || entitlement.screensInUse == null) { return false; }
  return entitlement.screensInUse >= entitlement.maxScreens;
}

// Payload-driven entitlement store fed by AppComponent.checkTrialStatus.
// State null = unknown (old backend, logged out, not yet fetched) = fail-open.
@Injectable()
export class EntitlementService {
  private store: BehaviorSubject<Entitlement | null> = new BehaviorSubject<Entitlement | null>(null);

  entitlement$: Observable<Entitlement | null> = this.store.asObservable();
  planId$: Observable<string | null> = this.store.map(function(e: Entitlement | null): string | null { return e ? e.planId : null; });
  planName$: Observable<string | null> = this.store.map(function(e: Entitlement | null): string | null { return e ? e.planName : null; });
  maxScreens$: Observable<number | null> = this.store.map(function(e: Entitlement | null): number | null { return e ? e.maxScreens : null; });
  screensInUse$: Observable<number | null> = this.store.map(function(e: Entitlement | null): number | null { return e ? e.screensInUse : null; });
  isAtCap$: Observable<boolean> = this.store.map(function(e: Entitlement | null): boolean { return isAtCap(e); });

  hasFeature$(key: string): Observable<boolean> {
    return this.store.map(function(e: Entitlement | null): boolean { return hasFeature(e, key); });
  }

  canUse$(check: (e: Entitlement | null) => boolean): Observable<boolean> {
    return this.store.map(check);
  }

  setFromStatus(status?: TrialStatusResponse | null): void {
    this.store.next(toEntitlement(status));
  }

  reset(): void {
    this.store.next(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/entitlement.service.ts